import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'booleanDisplay',
})
export class BooleanDisplayPipe implements PipeTransform {
    transform(value: boolean | null | undefined, fallback?: any): any {
        if (value === null || value === undefined) {
            return fallback;
        }
        return value ? 'Yes' : 'No';
    }
}